import React from 'react';

import gettingStartedIcon   from './img/gw2-icon-getting-started.png';
import gettingStartedBg     from './img/gw2-banner-getting-started.png';
import combatIcon           from './img/gw2-icon-combat.png';
import combatBanner         from './img/gw2-banner-combat.png';
import eventsIcon           from './img/gw2-icon-events.png';
import eventsBanner         from './img/gw2-banner-events.png';
import intoTyriaIcon        from './img/gw2-icon-into-tyria.png';
import intoTyriaBanner      from './img/gw2-banner-into-tyria.png';
import advancedCombatIcon   from './img/gw2-icon-advanced-combat.png';
import advancedCombatBanner from './img/gw2-banner-advanced-combat.png';
import yourStoryIcon        from './img/gw2-icon-your-story.png';
import yourStoryBanner      from './img/gw2-banner-your-story.png';
import communityIcon        from './img/gw2-icon-community.png';
import communityBanner      from './img/gw2-banner-community.png';
import yourInventoryIcon    from './img/gw2-icon-your-inventory.png';
import yourInventoryBanner  from './img/gw2-banner-your-inventory.png';

import * as css from './index.module.css';
import { i18n } from '../i18n';

// map section name to copy and images here
const lookup = {
    'getting-started' : {
        copy   : 'part1.gs.header',
        anchor : 'part1.gs.anchor',
        images : {
            icon : gettingStartedIcon,
            bg   : gettingStartedBg
        }
    },
    combat : {
        copy   : 'part1.c.header',
        anchor : 'part1.c.anchor',
        images : {
            icon : combatIcon,
            bg   : combatBanner
        }
    },
    events : {
        copy   : 'part2.e.header',
        anchor : 'part2.e.anchor',
        images : {
            icon : eventsIcon,
            bg   : eventsBanner
        }
    },
    'into-tyria' : {
        copy   : 'part2.it.header',
        anchor : 'part2.it.anchor',
        images : {
            icon : intoTyriaIcon,
            bg   : intoTyriaBanner
        }
    },
    'advanced-combat' : {
        copy   : 'part3.ac.header',
        anchor : 'part3.ac.anchor',
        images : {
            icon : advancedCombatIcon,
            bg   : advancedCombatBanner
        }
    },
    'your-story' : {
        copy   : 'part3.ys.header',
        anchor : 'part3.ys.anchor',
        images : {
            icon : yourStoryIcon,
            bg   : yourStoryBanner
        }
    },
    community : {
        copy   : 'part4.c.header',
        anchor : 'part4.c.anchor',
        images : {
            icon : communityIcon,
            bg   : communityBanner
        }
    },
    'your-inventory' : {
        copy   : 'part4.yi.header',
        anchor : 'part4.yi.anchor',
        images : {
            icon : yourInventoryIcon,
            bg   : yourInventoryBanner
        }
    },
};

export default function SectionHeader({ name }) {
    const section = lookup[name];
    const href    = i18n(section.anchor, { md : false })
        .toLowerCase()
        .replace(' ', '');

    return (
        <div className={css.sectionHeader} id={href} title={i18n(section.copy, { md : false })} style={{ backgroundImage : `url(${section.images.bg})` }} >
            <h2 className={css.headerText}>
                <img className={css.headerIcon} src={section.images.icon} />
                <a href={`#${href}`} className={css.headerLabel}>{i18n(section.copy)}</a>
            </h2>
        </div>
    );
}
